__webpack_require__.p = "https://static.magicsquare.io/swap/_next/";